import React, { useState, useEffect } from 'react';
import './DesktopPrototype.css';

const DesktopPrototype = () => {
  const [currentImage, setCurrentImage] = useState(1);
  const totalImages = 7;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev % totalImages) + 1);
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="desktop-prototype">
      {/* Background Carousel */}
      <div className="carousel-background">
        {[...Array(totalImages)].map((_, index) => (
          <div
            key={index + 1}
            className={`carousel-image ${currentImage === index + 1 ? 'active' : ''}`}
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/carrousel${index + 1}.jpeg)`
            }}
          />
        ))}
        <div className="carousel-overlay" />
      </div>

      {/* Content */}
      <div className="content-container">
        <header className="header">
          <h1 className="title">ARTAUD SINFÓNICO</h1>
          <p className="subtitle">Una experiencia musical inmersiva</p>
        </header>

        <main className="main-content">
          <section className="info-section">
            <h2>Sobre el Proyecto</h2>
            <p>
              Artaud Sinfónico es una obra que fusiona la intensidad poética de
              Antonin Artaud con la potencia de una orquesta sinfónica completa.
            </p>
          </section>

          <section className="details-section">
            <div className="detail-card">
              <h3>Compositor</h3>
              <p>Información del compositor</p>
            </div>
            <div className="detail-card">
              <h3>Orquesta</h3>
              <p>Información de la orquesta</p>
            </div>
            <div className="detail-card">
              <h3>Fecha</h3>
              <p>Próximas presentaciones</p>
            </div>
          </section>
        </main>

        {/* Carousel indicators */}
        <div className="carousel-indicators">
          {[...Array(totalImages)].map((_, index) => (
            <button
              key={index + 1}
              className={`indicator ${currentImage === index + 1 ? 'active' : ''}`}
              onClick={() => setCurrentImage(index + 1)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default DesktopPrototype;